import React from 'react'
import { Link } from 'react-router-dom'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { ThreeColumnsSlice } from 'modules/prismic'
import { Box, Wrapper } from './styled'

export const ThreeColumns = ({ primary, items }: ThreeColumnsSlice) => {
  const { heading, sub_heading: subHeading } = primary
  return (
    <Wrapper>
      {PrismicRichText.render(heading)}
      {PrismicRichText.render(subHeading)}
      <div className='container'>
        {items.map((item, idx) => {
          const {
            icon,
            heading,
            sub_heading: subHeading,
            content,
            content_alignment: alignment,
            button_url: buttonUrl,
            button_label: buttonLabel,
            bg
          } = item

          return (
            <Box
              textAlignment={alignment}
              key={idx}
              style={bg?.url ? { backgroundImage: `url(${bg.url})`, color: '#fff' } : undefined}
            >
              {icon.url && (
                <img className='icon' src={icon.url} alt={icon.alt ?? ''} width={icon.dimensions?.width} height={icon.dimensions?.height} />
              )}
              {PrismicRichText.render(heading)}
              {PrismicRichText.render(subHeading)}
              {PrismicRichText.render(content)}
              {buttonLabel && buttonUrl && (
                <Link to={buttonUrl} className='btn'>{buttonLabel}</Link>
              )}
            </Box>
          )
        })}
      </div>
    </Wrapper>
  )
}
